import { HUBSPOT_CASE_STUDIES_FORM_ID } from "../api/hubspot";
import WhitepaperPage from "./WhitepaperPage";

// 資料「AI導入は何を変えたのか 事例サーベイ」のダウンロードページ
// （/whitepaper/ai-case-studies）。
//
// 国内外34件（31社）のAI導入事例を、会社の発表や行政の資料までさかのぼって集めた市場調査。
// 当社の支援実績ではない。ページでも実績のように見せないこと。
//
// 原本は Google Drive の【LEAPS】AI導入事例サーベイ_v31（pptx / pdf）。
// 原本は全ページに「Confidential」が入っているため、配布版はその文字だけを
// 消して書き出している。更新したら同じ処理をしてから
// public/downloads/ と public/images/whitepaper/ai-case-studies/ を入れ替えること。

const DIR = "/images/whitepaper/ai-case-studies";

function WhitepaperAiCaseStudies() {
  return (
    <WhitepaperPage
      formId={HUBSPOT_CASE_STUDIES_FORM_ID}
      leadKind="whitepaper_ai_case_studies"
      title="国内外34のAI導入事例サーベイ"
      lead="資料「AI導入は何を変えたのか」。国内外のAI導入事例34件（31社、うち中小企業7社）を、業務の種類ごとに1事例1ページでまとめた経営者向けの資料です。効果が出た仕事の特徴と、最初の一歩が分かります。フォーム送信後、すぐにダウンロードいただけます。"
      pdfHref="/downloads/leaps-ai-case-studies.pdf"
      spec="全46ページ ／ PDF ／ 2026年9月版"
      cover={`${DIR}/page-1.png`}
      inside={[
        { src: `${DIR}/page-7.png`, cap: "業務別の早見表" },
        { src: `${DIR}/page-9.png`, cap: "1事例1ページ" },
        { src: `${DIR}/page-44.png`, cap: "共通する3条件" },
      ]}
      topics={[
        "34事例（国内29・海外5、うち中小企業7）の導入前後と効果の数字",
        "書類作成・調べもの・発注・問い合わせ対応など、10種類の業務ごとの早見表",
        "効果とまでは言い切れない数字と、公表されていないことの見分け方",
        "効果が出た会社に共通する3つの条件と、最初の一歩",
      ]}
    />
  );
}

export default WhitepaperAiCaseStudies;
